import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import { EventType } from '@ispm/shared/bpmn-io/bpmn-js';
import { getElement, ifNodeOfTypeByNodeDetailes } from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/command-interceptor-utils';
import { constants } from '@ispm-client/modules/bpmn-modeler/constants/constants';
import { OverlayUtils } from '@ispm-client/modules/bpmn-modeler/bpmn/utils/overlay-utils';
import { Shape } from 'diagram-js/lib/model';
import { TreeNavigator } from '@ispm/shared/bpmn-io/services/tree-navigator';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { OverlayType } from '@ispm/shared/bpmn-io/overlay-types';

export class NeighborhoodNodeOverlayBehavior extends CommandInterceptor {

  constructor(eventBus: EventBus, protected overlays, protected treeNavigator: TreeNavigator) {
    super(eventBus);
    super.postExecuted([EventType.SHAPE_REPLACE], ifNodeOfTypeByNodeDetailes(this.handleNeighborhoodHeadOverlayOnReplace.bind(this), NodeType.neighborhood_head));
    eventBus.on([EventType.SHAPE_ADDED], (event) => {
      const element = event.element;
      if (ModelingUtil.getNodeType(element) === NodeType.neighborhood_entry) {
        event.context = { node: element};
        this.addNeighborhoodEntryOverlay(event);
      }
      if (ModelingUtil.getNodeType(element) === NodeType.neighborhood_head) {
        event.context = { node: element};
        this.addNeighborhoodHeadOverlay(event);
      }
    });
  }

  addNeighborhoodEntryOverlay(event) {
    const node = event.context.node;
    //Activity Id indicates that the node is being created
    const leftFactor = node.di && node.di.id.startsWith('Activity') ? 0 : 9;
    const overlayId = this.overlays.add(node.id, OverlayType.neighborhoodEntryOverlay, {
      position: {
        top: -1,
        left: constants.NEIGHBORHOOD_NODE_DIMENSIONS.width - constants.OVERLAY_ICON.width + 1 - leftFactor
      },
      html: '<div class="neighborhood-overlay-container neighborhood-entry icon__ArrowRight"></div>'
    });
    const overlay = this.overlays.get(overlayId);
    overlay.htmlContainer.onclick = navigationOnClick(this.neighborhoodEntryOnClick.bind(this), node);
    OverlayUtils.updateOverlayBounds(node.height, overlay);
  }


  addNeighborhoodHeadOverlay(event) {
    const node = event.context.node;
    const overlayId = this.overlays.add(node.id, OverlayType.neighborhoodHeadOverlay, {
      position: {
        top: -1,
        left: -1
      },
      html: '<div class="neighborhood-overlay-container neighborhood-head icon__ArrowLeft"></div>'
    });
    const overlay = this.overlays.get(overlayId);
    overlay.htmlContainer.onclick = navigationOnClick(this.navigateToMainTree.bind(this), node);
    OverlayUtils.updateOverlayBounds(node.height, overlay);
  }

  handleNeighborhoodHeadOverlayOnReplace(event) {
    event.context.node = getElement(event.context);
    // remove old overlay
    this.overlays.remove({ element: event.context.node.id, type: OverlayType.neighborhoodHeadOverlay});
    this.addNeighborhoodHeadOverlay(event);
  }

  neighborhoodEntryOnClick(neighborhoodEntryNode: Shape) {
    this.navigateToSubTree(neighborhoodEntryNode);
  }

  navigateToSubTree(neighborhoodEntryNode: Shape) {
    this.treeNavigator.navigateToSubTree(neighborhoodEntryNode);
  }

  navigateToMainTree(node: Shape) {
    this.treeNavigator.navigateToMainTreeByHeadAndFocusOnRoot(node);
  }

}

export function navigationOnClick(fn, node) {
  return function () {
    fn(node);
  };
}

NeighborhoodNodeOverlayBehavior.$inject = [...CommandInterceptor.$inject, 'overlays', 'treeNavigator'];
